var _defs, _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".aBin{fill:none;}.bBin{fill:#b30200;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "aBin",
    width: 32,
    height: 32,
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "bBin",
    d: "M10,2,9,3H3V5H4.109L5.9,20.234A2.01,2.01,0,0,0,7.889,22h8.223A2.01,2.01,0,0,0,18.1,20.234L19.891,5H21V3H15L14,2ZM6.123,5H17.877L16.111,20H7.889ZM9,7V17a1,1,0,0,0,1,1h1V7Zm4,0V18h1a1,1,0,0,0,1-1V7Z",
    transform: "translate(4 4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.733da2764c53bc722b7882c6d4e95ac8.svg";
export { ForwardRef as ReactComponent };